import { memo } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

function FundingAggregatorNameForm({ fundingConsumerAggregatorName }) {
  return (
    <>
      <Col md={2} className="bo-same-line">
        <Form.Label>Aggregator Name:</Form.Label>
      </Col>
      <Col md={4} className="bo-same-line">
        <Form.Control
          className="bo-input"
          type="text"
          name="aggregatorName"
          id="aggregatorName"
          value={fundingConsumerAggregatorName || ''}
          readOnly
        />
      </Col>
    </>
  );
}

export default memo(FundingAggregatorNameForm);
